import request from '@/utils/request'
import axios from 'axios'
import {
  getToken
} from '@/utils/auth'
const BaseUrl = '/monthkpi'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 30000
})
// 查询列表
export function getMonthKpiPage(params) {
  return request({
    url: `${BaseUrl}`,
    method: 'get',
    params
  })
}

// 月度kpi新增
export function saveMonthKpi(data) {
  return request({
    url: `${BaseUrl}`,
    method: 'post',
    data
  })
}

// 月度kpi删除
export function delMonthKpi(id) {
  return request({
    url: `${BaseUrl}/delete/${id}`,
    method: 'delete'
  })
}

// 月度kpi作废
export function cancelMonthKpi(id) {
  return request({
    url: `${BaseUrl}/cancel/${id}`,
    method: 'post'
  })
}

// 月度kpi提交
export function submitMonthKpi(id) {
  return request({
    url: `${BaseUrl}/submit/${id}`,
    method: 'post'
  })
}

// 月度kpi详情
export function getMonthKpi(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

export function exportListDataExcel(that) {
  debugger
  service({
    method: 'post',
    url: '/monthkpi/exportDataList',
    //   params: {
    //     startTime: startTime,
    //     endTime: endTime
    //   },
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob'
  }).then(response => {
    debugger
    const fileName = `月度业绩报表导出.xlsx`
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel'
    })
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = fileName
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
    // that.downloadLoading.close();
  }).catch(error => {
    console.log(error)
  })
}
